import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type LdFlagOverrides = Record<string, boolean>;

interface DevLdFlagOverridesState {
  overrides: LdFlagOverrides;
  setOverride: (key: string, value: boolean | null) => void;
  clearOverrides: () => void;
}

// Client-only store — LD flags are evaluated in the browser via
// `launchdarkly-react-client-sdk`, so no cookie or server-side bridge is needed.
// Persists to localStorage so toggles survive reloads in development.
export const useDevLdFlagOverridesStore = create<DevLdFlagOverridesState>()(
  persist(
    (set) => ({
      overrides: {},
      setOverride: (key, value) =>
        set((state) => {
          const next = { ...state.overrides };
          if (value === null) {
            delete next[key];
          } else {
            next[key] = value;
          }
          return { overrides: next };
        }),
      clearOverrides: () => set({ overrides: {} }),
    }),
    { name: 'bridge-dev-ld-flag-overrides' }
  )
);
